import { useRootFontSizeScale } from "../../hooks/useRootFontSizeScale/index.js";
import { createGlobalStyleSheet as GlobalStyleWithParameters } from "./Global.style.js";
import { GlobalProps } from "./Global.types.js";

export const GlobalStyle = ({ useFontSizeScale, addMainBackground, mainFontColor }: GlobalProps) => {
    const fontSize = useRootFontSizeScale();

    return (
        <GlobalStyleWithParameters fontSize={useFontSizeScale ? fontSize : 16} addMainBackground={addMainBackground} mainFontColor={mainFontColor} />
    );
};
